import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <UpdatesSection />
        <CardsSection />
        <IndexSection />
        <TopicsSection />
        <ContactSection />
        <FeaturesSection />
        <RankingSection />
        <MediaSection />
        <CarouselSection />
        <CommentsSection />
        <AboutSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}